import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  GridSize,
  TextField
} from '@material-ui/core';
import { navigate } from 'gatsby';
import React, { useEffect } from 'react';

interface Props {
  formId: string;
  className?: string;
  redirectUrl: string;
  dark?: boolean;
}

const HubspotForm: React.FC<Props> = props => {
  const [formData, setFormData] = React.useState({
    portalId: '',
    method: 'POST',
    submitText: 'Submit',
    formFieldGroups: [],
  });

  useEffect(() => {
    fetch(`/api/forms?formId=${props.formId}`)
      .then(res => res.json())
      .then(data => {
        setFormData(data);
      });
  }, []);

  const action = `https://forms.hubspot.com/uploads/form/v2/${formData.portalId}/${props.formId}`;

  const onSubmit = (event: any) => {
    navigate(props.redirectUrl);
  };

  if (!formData || !formData.portalId) {
    return (
      <div style={{ textAlign: 'center' }}>
        <CircularProgress color="primary" />
      </div>
    );
  } else {
    return (
      <form className={props.className} method="POST" action={action} onSubmit={e => onSubmit(e)}>
        {formData.formFieldGroups.map((group, index) => (
          <Grid container key={index} justifyContent="flex-start" spacing={4}>
            {group.fields.map(field => (
              <Grid
                item
                key={field.name}
                lg={
                  group.fields.length <= 4 && group.fields.length > 0
                    ? ((12 / Number(group.fields.length)) as GridSize)
                    : 3
                }
                xs={12}
              >
                <FormControl fullWidth>
                  <TextField
                    name={field.name}
                    label={field.labelHidden ? '' : field.label}
                    type={field.type}
                    required={field.required}
                    hidden={field.hidden}
                    disabled={!field.enabled}
                    placeholder={field.placeholder}
                    multiline={field.fieldType === 'textarea'}
                    rows={5}
                    variant="outlined"
                    margin="normal"
                  />
                </FormControl>
              </Grid>
            ))}
          </Grid>
        ))}

        <div>&nbsp;</div>

        <Button variant={props.dark ? 'outlined' : 'contained'} color="primary" type="submit">
          {formData.submitText}
        </Button>
      </form>
    );
  }
};

export default HubspotForm;
